import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const ContactPerson = (props) => {
  return (
    <FormGroup controlId="contactPerson">
      <Col componentClass={ControlLabel} sm={5}>
        Contact Person
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.contactPerson} onChange={props.handleChangeContactPerson}
          autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

ContactPerson.propTypes = {
  contactPerson: PropTypes.string,
  handleChangeContactPerson: PropTypes.func
};

export default ContactPerson;



// WEBPACK FOOTER //
// ./src/app/components/contactPerson/ContactPerson.js